export default __webpack_public_path__ + "static/media/banner-12.779e3964.png";